module.exports = __webpack_public_path__ + "static/media/Logo_fema_ALTA-01.9b714ac8.png";